<template lang="pug">
div
  PageTitle
  EditLottery(ref='editLottery' @success='success')
  LotteryResult(ref='lotteryResult')

  //- 載入失敗訊息
  v-alert(type='error' :value='true' v-if='lotteries === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}

  //- 麵包屑
  LotteryBreadcrumb

  v-card.mb-2
    v-toolbar(flat)
      v-spacer
      v-btn(flat icon color='primary' @click='clickAdd' :loading='!lotteries'): v-icon add
      v-menu(bottom right offset-y :disabled='!lotteries')
        v-btn(slot='activator' icon): v-icon more_vert
        v-list
          v-list-tile(@click='isWinnerDetailShow = !isWinnerDetailShow')
            v-list-tile-action: v-icon fas fa-info-circle
            v-list-tile-title {{ isWinnerDetailShow ? `隱藏` : `顯示`}}得獎者詳細資訊

  Loader(:show='lotteries === null')

  v-card(v-if='lotteries && lotteries.length === 0')
    v-card-text: h6.grey--text 點擊右上角 + 按鈕建立抽獎活動

  v-card.mb-2(v-for='(i, index) in lotteries' :key='index' @click='clickEdit(i.id)' ripple)
    v-img.white--text(height='120' min-height='120' :src='i.photo || `http://1x1px.me/333333-0.8.png`' gradient=`to top, rgba(0, 0, 0, .5) , rgba(0, 0, 0, .5) `)
      v-container(fluid)
        v-layout
          v-flex(xs12 flexbox)
            h3.title.mb-3 {{ i.title }}
            p {{ i.content }}

    v-card-text
      v-layout(row wrap)
        v-flex(xs12 sm6 md3)
          v-subheader.pl-0 開始
          .pl-1 {{ i.begin | time }}
        v-flex(xs12 sm6 md3)
          v-subheader.pl-0 結束
          .pl-1 {{ i.end | time  }}
        v-flex(xs12 sm6 md3)
          v-subheader.pl-0 參與人數
          .pl-1(v-if='i.participant') {{ i.participant.length }} 人
          .pl-1(v-else) 0 人
        v-flex(xs12 sm6 md3)
          v-subheader.pl-0 抽出人數
          .pl-1 {{ i.numOfWinner }} 人

        v-flex(xs12 md3)
          v-subheader.pl-0 狀態
          .pl-1
            v-chip(:color='i.isOpen ? `green` : `grey darken-2`' text-color='white')
              v-avatar: v-icon {{ i.isOpen ? `check_circle` : `remove_circle` }}
              span(v-if='i.isOpen') 已開放使用者參加
              span(v-else) 未開放使用者參加
            v-chip(:color='i.isShow ? `green` : `grey darken-2`' text-color='white')
              v-avatar
                v-icon(v-if='i.isShow') check_circle
                v-icon(v-else small) fas fa-eye-slash
              span(v-if='i.isShow') 已顯示
              span(v-else) 已隱藏

        v-flex(xs12 md9)
          v-subheader.pl-0 得獎者
          .pl-1(v-if='i.winner')
            v-container.pa-0(grid-list-sm v-if='isWinnerDetailShow')
              v-layout(row wrap)
                v-flex(xs12 sm6 md4 v-for='(w, wIndex) in i.winner' :key='wIndex' )
                  LotteryWinnerCard(:data='w')
            v-chip(v-else v-for='(w, wIndex) in i.winner' :key='wIndex')
              v-avatar.amber {{ w.name[0] }}
              | {{ w.name }}

          template(v-else)
            v-menu(v-model='i.menu' :close-on-content-click='false' @click.native.stop max-width='250')
              v-btn(slot='activator' color='amber' light v-if='lotteries' :disabled='isDrawing')
                v-icon.mr-2(small) fas fa-ticket-alt
                | 抽獎
              v-card
                v-card-text
                  div 是否確認抽出此獎得獎者?
                  .mt-1(v-if='+new Date() < i.end '): small.red--text
                     v-icon.mr-1(small color='red') fas fa-exclamation-triangle
                     b 此獎項尚在報名階段，若確定抽出獎項後將會使該抽獎活動關閉
                v-card-actions
                  v-spacer
                  v-btn(flat @click='i.menu = false' :disabled='isDrawing') {{ $t('cancel') }}
                  v-btn(color='primary' flat @click='draw(i.id, { title: i.title, photo: i.photo })' :loading='isDrawing') 確認
  DebugCodeBlock(:value='lotteries')
  SnackbarSuccess(ref='successSnackbar')
</template>

<script>
import apis from '@/assets/js/apis'
import { formStatus } from '@/mixins/formStatus'

import Loader from '@/components/Loader.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import PageTitle from '@/components/PageTitle.vue'

import EditLottery from '@/components/lottery/EditLottery.vue'
import LotteryWinnerCard from '@/components/lottery/LotteryWinnerCard.vue'
import LotteryResult from '@/components/lottery/LotteryResult.vue'
import LotteryBreadcrumb from '@/components/lottery/LotteryBreadcrumb.vue'

export default {
  name: 'Lottery',
  metaInfo () {
    return {
      title: this.$t('抽獎'),
    }
  },
  data () {
    return {
      lotteries: null,
      isWinnerDetailShow: false,
      isDrawing: false,
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    clickEdit (id) {
      if (this.isDrawing) return
      const params = { period: this.period, id }
      this.$refs.editLottery.init(params)
    },
    clickAdd () {
      if (this.isDrawing) return
      const params = { period: this.period }
      this.$refs.editLottery.addNew(params)
    },
    success (type) {
      this.isRefetching = true
      this.fetch()
      const messages = {
        add: '成功建立新的抽獎活動',
        remove: '成功移除抽獎活動',
        removeWinner: '成功清空現有得獎者',
      }
      this.$refs.successSnackbar.show(messages[type] || '成功編輯抽獎活動')
    },
    async fetch () {
      const params = { period: this.period }
      this.lotteries = null

      try {
        this.lotteries = await apis.lotteries.get(params, this.token)
      } catch (e) {
        this.lotteries = false
        this.error = e
      }
    },
    draw (id, info) {
      // if (!confirm(`是否確認抽出此獎得獎者？`)) return
      const params = { period: this.period, lotteryId: id }
      this.isDrawing = true

      apis.lottery.draw(params, this.token).then(result => {
        this.isDrawing = false
        this.$refs.lotteryResult.show(result, info)
        this.fetch()
      }).catch(e => {
        this.isDrawing = false
        this.error = e
      })
    },
  },
  computed: {
    period () {
      return parseInt(this.$route.params.period)
    },
  },
  components: {
    Loader,
    EditLottery,
    SnackbarSuccess,
    PageTitle,
    LotteryWinnerCard,
    LotteryResult,
    LotteryBreadcrumb,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
p
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  -webkit-line-clamp: 2
  -webkit-box-orient: vertical
</style>
